import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {fromEvent} from 'rxjs';
import {distinctUntilChanged, pairwise, switchMap, takeUntil} from 'rxjs/operators';
import {CanvasService} from '../../../core/services/canvas.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-canvas',
  templateUrl: './canvas.component.html',
  styleUrls: ['./canvas.component.scss']
})
export class CanvasComponent implements OnInit {


  @Input() public canvasWidth = 660;
  @Input() public canvasHeight = 300;
  @Input() public isConfigSignDefault = false;
  @Input() public isSignflowDocument = false;
  @Output() applySignatureImage = new EventEmitter();
  public disableBtnDeleteCanvas = true;
  public disableBtnApplyCanvas = true;

  // @Output() onGetCanvasImage = new EventEmitter<File>();

  @ViewChild('myCanvas', {static: true}) canvas: ElementRef;

  private cx: CanvasRenderingContext2D;
  currentColour = '#0000ff';
  brushSize = 5;
  deviceInfo = null;
  signaturePad: any;

  // private drawCanvas = document.querySelector('drawCanvas') as HTMLCanvasElement;
  // public signaturePad = new SignaturePad(this.drawCanvas, {
  //   minWidth: this.canvasWidth,
  //   penColor: '#0000ff'
  // });

  constructor(
    private canvasService: CanvasService,
    private cd: ChangeDetectorRef,
    public deviceService: DeviceDetectorService) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
  }

  ngOnInit() {
    this.canvasService.isSelectSignDraw.pipe(distinctUntilChanged()).subscribe(result => {
      if (result === true) {
        this.configCanvas();
      }
    });

    this.canvasService.isDisableBtnDeleteCanvas.subscribe(result => {
      this.disableBtnDeleteCanvas = result;
    });

    this.canvasService.isApplyDrawSignature.subscribe(result => {
      this.disableBtnApplyCanvas = result;
    });
  }


  configCanvas() {
    if (!this.canvas) {
      return;
    }
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    // canvasEl.width = this.canvasWidth;
    // canvasEl.height = this.canvasHeight;
    // this.cx.lineWidth = 5;
    // this.cx.lineCap = 'round';
    // this.cx.strokeStyle = '#000';

    // const drawCanvas = document.querySelector('drawCanvas') as HTMLCanvasElement;
    this.signaturePad = new SignaturePad(canvasEl, {
      minWidth: 2,
      maxWidth: 2,
      penColor: '#0000ff',
      dotSize: 0.5,
    });

    this.signaturePad.addEventListener('beginStroke', () => {
      this.canvasService.setIsDisableBtnDeleteCanvas(false);
      // nét vẽ mới => nội dung canvas chưa được Áp dụng
      this.canvasService.setIsApplyDrawSignature(false);
    }, {once: false});

    // this.captureEvents(canvasEl);
  }

  private captureEvents(canvasEl: HTMLCanvasElement) {
    // this will capture all mousedown events from the canvas element
    fromEvent(canvasEl, 'mousedown')
      .pipe(
        switchMap((e) => {
          // after a mouse down, we'll record all mouse moves
          return fromEvent(canvasEl, 'mousemove')
            .pipe(
              // we'll stop (and unsubscribe) once the user releases the mouse
              // this will trigger a 'mouseup' event
              takeUntil(fromEvent(canvasEl, 'mouseup')),
              // we'll also stop (and unsubscribe) once the mouse leaves the canvas (mouseleave event)
              takeUntil(fromEvent(canvasEl, 'mouseleave')),
              // pairwise lets us get the previous value to draw a line from
              // the previous point to the current point
              pairwise()
            );
        })
      )
      .subscribe((res: [MouseEvent, MouseEvent]) => {
        const rect = canvasEl.getBoundingClientRect();

        // previous and current position with the offset
        const prevPos = {
          x: res[0].clientX - rect.left,
          y: res[0].clientY - rect.top
        };

        const currentPos = {
          x: res[1].clientX - rect.left,
          y: res[1].clientY - rect.top
        };

        // this method we'll implement soon to do the actual drawing
        this.drawOnCanvas(prevPos, currentPos);
      });

    // this will capture all touchstart events from the canvas element
    fromEvent(canvasEl, 'touchstart')
      .pipe(
        switchMap((e) => {
          // after a mouse down, we'll record all mouse moves
          return fromEvent(canvasEl, 'touchmove')
            .pipe(
              // we'll stop (and unsubscribe) once the user releases the mouse
              // this will trigger a 'mouseup' event
              takeUntil(fromEvent(canvasEl, 'touchend')),
              // we'll also stop (and unsubscribe) once the mouse leaves the canvas (mouseleave event)
              takeUntil(fromEvent(canvasEl, 'touchcancel')),
              // pairwise lets us get the previous value to draw a line from
              // the previous point to the current point
              pairwise()
            );
        })
      )
      .subscribe((res: [TouchEvent, TouchEvent]) => {
        const rect = canvasEl.getBoundingClientRect();

        // previous and current position with the offset
        const prevPos = {
          x: res[0].touches[0].clientX - rect.left,
          y: res[0].touches[0].clientY - rect.top
        };

        // res[0].preventDefault();
        // res[0].stopImmediatePropagation();

        const currentPos = {
          x: res[1].touches[0].clientX - rect.left,
          y: res[1].touches[0].clientY - rect.top
        };

        // res[1].preventDefault();
        // res[1].stopImmediatePropagation();

        // this method we'll implement soon to do the actual drawing
        this.drawOnCanvas(prevPos, currentPos);
      });
  }


  private drawOnCanvas(prevPos: { x: number, y: number }, currentPos: { x: number, y: number }) {
    this.canvasService.setIsDisableBtnDeleteCanvas(false);
    // this.disableBtnDeleteCanvas = false;
    if (!this.cx) {
      return;
    }
    this.cx.beginPath();
    if (prevPos) {
      this.cx.moveTo(prevPos.x, prevPos.y); // from
      this.cx.lineTo(currentPos.x, currentPos.y);
      this.cx.closePath();
      this.cx.strokeStyle = this.currentColour;
      this.cx.lineWidth = this.brushSize;
      this.cx.stroke();
    }
  }

  clearCanvas() {
    this.canvasService.setIsDisableBtnDeleteCanvas(true);
    this.canvasService.setIsApplyDrawSignature(false);
    if(this.cx) {
      this.cx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
    }
  }

  handleOk(): void {
    this.canvasService.setIsVisibleModalDrawSignature(false);
    this.onSaveCanvas();
  }

  onSaveCanvas(isConfigSignatureDefault?: boolean): void {
    if (!this.signaturePad || this.signaturePad.isEmpty()) {
      return;
    }
    this.canvasService.setIsApplyDrawSignature(true);
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    const resizedCanvas = document.createElement('canvas');
    const resizedContext = resizedCanvas.getContext('2d');
    resizedCanvas.height = this.isConfigSignDefault ? this.canvasHeight * 4 : 200;
    resizedCanvas.width = this.isConfigSignDefault ? this.canvasWidth * 4 : 440;
    resizedContext.drawImage(canvasEl, 0, 0, this.isConfigSignDefault ? this.canvasWidth * 4 : 440, this.isConfigSignDefault ? this.canvasHeight * 4 : 200);

    const imageUrl = resizedCanvas.toDataURL();
    if (isConfigSignatureDefault) {
      this.applySignatureImage.emit(resizedCanvas.toDataURL());
    }
    this.canvasService.setCanvasImageUrl(imageUrl);
    if(this.isSignflowDocument) {
      this.canvasService.setCanvasSignatureImageUrl(imageUrl);
    }
    // const imageUrl = canvasEl.toDataURL();
    // this.imageUrlPreview = imageUrl;
    fetch(imageUrl)
      .then(r => r.blob())
      .then(blobFile => {
        const fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
        this.canvasService.setCanvasImage(fileUpload);
        if(this.isSignflowDocument) {
          this.canvasService.setCanvasSignatureImage(fileUpload);
        }
      });
  }

  onSaveCanvasWithName(name: string): void {
    if (!this.signaturePad || this.signaturePad.isEmpty()) {
      return;
    }
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    const resizedCanvas = document.createElement('canvas');
    const resizedContext = resizedCanvas.getContext('2d');
    resizedCanvas.height = 200;
    resizedCanvas.width = 440;
    resizedContext.drawImage(canvasEl, 0, 0, 440, 200);

    const imageUrl = resizedCanvas.toDataURL();
    this.canvasService.setCanvasImageUrl(imageUrl);
    // const imageUrl = canvasEl.toDataURL();
    // this.imageUrlPreview = imageUrl;
    fetch(imageUrl)
      .then(r => r.blob())
      .then(blobFile => {
        const fileUpload = new File([blobFile], name, {type: 'image/png'});
        this.canvasService.setCanvasImage(fileUpload);
      });
  }

  changeColorDrawCanvas(data: string) {
    this.signaturePad.penColor = data;
    this.cd.detectChanges();
  }

  changeEraserDrawCanvas(data: number) {
    this.signaturePad.minWidth = data;
    this.signaturePad.maxWidth = data;
    this.cd.detectChanges();
  }
}
